<template>
  <div ref="scrollComponent" id="edz_scroller">
    <div class="md:hidden sticky top-0 bg-white p-5 z-50">
      <header class="flex justify-between">
        <h1 class="text-2xl font-bold">Sessions <span class="text-xs uppercase font-bold">{{ timezone }}</span></h1>
        <div @click="makeCompact" class="cursor-pointer">{{ goCompactMessage }}</div>
      </header>
    </div>
    <div class="md:sticky md:top-0 md:bg-white z-50 pb-6 pt-6">
      <header class="hidden md:flex justify-between">
        <h1 class="text-2xl font-bold">Sessions</h1>
        <div @click="makeCompact" class="cursor-pointer">{{ goCompactMessage }}</div>
      </header>
      <div class="p-3 hidden">
        <div>All Fetched: {{ isAllFetched }} Get Data : {{ doGetData }} NextPage: {{ nextPage }} Getting: {{
            isGetting
          }}
        </div>
        <button @click="makeCompact">Make Compact</button>
        <div>Compactness: {{ compactness }}</div>
      </div>
      <div class="grid grid-cols-6 gap-y-1 sm:gap-y-6 gap-x-2 sm:gap-x-6 mt-6 sm:grid-cols-6">
        <div v-show="localDays.length > 1" class="sm:col-span-3 col-span-3">
          <label class="hidden sm:block text-sm font-medium text-gray-700">Date (<a class="underline text-red-600" href="https://edzil.la/user/settings">{{ timezone }}</a>)</label>
          <select @change="changeSearch($event)" v-model="selectedDay"
                  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm rounded-md">
            <option value="0" selected="selected">Any Date</option>
            <option value="hours-24">Next 24 hours</option>
            <option v-for="localDay in localDays" :value="localDay.date">{{ localDay.format }}</option>
          </select>
        </div>
        <div v-show="sessionTypes.length > 1" class="sm:col-span-3 col-span-3">
          <label class="hidden sm:block text-sm font-medium text-gray-700">Type</label>
          <select @change="changeSearch($event)" v-model="selectedType"
                  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm rounded-md">
            <option value="0" selected="selected">Any Type</option>
            <option v-for="sessionType in sessionTypes" :value="sessionType.id">{{ sessionType.name }}</option>
          </select>
        </div>
        <div v-show="sessionSubTypes.length > 1" class="sm:col-span-3 col-span-3">
          <label class="hidden sm:block text-sm font-medium text-gray-700">Subtype</label>
          <select @change="changeSearch($event)" v-model="selectedSubType"
                  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm rounded-md">
            <option value="0" selected="selected">Any Subtype</option>
            <option v-for="sessionSubType in sessionSubTypes" :value="sessionSubType.id">{{
                sessionSubType.name
              }}
            </option>
          </select>
        </div>

        <div v-show="sessionFormats.length > 1" class="sm:col-span-3 col-span-3">
          <label class="hidden sm:block text-sm font-medium text-gray-700">Format</label>
          <select @change="changeSearch($event)" v-model="selectedFormat"
                  class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm rounded-md">
            <option value="0" selected="selected">Any Format</option>
            <option v-for="sessionFormat in sessionFormats" :value="sessionFormat.id">{{
                sessionFormat.name
              }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="sessions">
      <p class="mb-4">All times are in <a class="underline text-red-600" href="https://edzil.la/user/settings">{{timezone}}</a> which you can <a class="underline text-red-600" href="https://edzil.la/user/settings">change</a>.</p>
      <ul>
        <li class="session-wrap mx-auto mb-8 flex w-full flex-wrap lg:flex-nowrap" v-for="(session, index) in sessions"
            :key="session.id">
          <div
              class="relative mx-auto basis-full items-center justify-between rounded-xl p-6 font-bold text-white md:flex lg:flex-1 lg:basis-0 bg-gradient"
              :class="newDate(sessions[index-1],session)">
            <div class="flex-1 md:mx-[2.5rem] md:flex md:space-x-6">
              <div class="px-4 md:flex-1 md:px-0">
                <header :class="{'mb-1 lg:mb-4' : compactness < 2, 'mb-4' : compactness >= 2}">
                  <div class="flex items-center">

                    <a :href="sessionLeadLink(session)" v-show="compactness<2" class="mr-2 flex-none hidden md:block">
                      <img class="mx-auto h-12 w-12 rounded-full border-4 border-white border-opacity-25"
                           :src="sessionLeadImage(session)" alt="Lead Presenter"
                      >
                    </a>
                    <div>
                      <h4 class="text-xs font-bold uppercase text-white text-opacity-75">
                        <template v-for="(p,index) in session.participants" :key="p.id">

                          <span v-show="index > 0" class="_delim color-black"> / </span>
                          <a class="inherits-color link md:inline" :class="{'hidden': (index >= 2)}"
                             :href="'/person/'+p.member?.id">
                            {{ participantName(p) }}
                          </a>
                        </template>
                        <span class="md:hidden" v-show="participantCountGreater(session, 2)"> and others</span></h4>
                      <h1 class="header-gradient font-bold leading-tight"
                          :class="{'text-xl md:text-2xl  widescreen:text-3xl' : compactness < 2, 'text-xl' : compactness >= 2  }">
                        <a :href="'/session/' + session.id">{{ session.title }}
                        </a> <span
                          class="text-sm">#{{ session.id }}</span></h1>
                    </div>
                    <button @click="toggleFavorite(session)"
                            :title="hasBeenFavorited(session) ? 'Unfavorite this': 'Favorite this'"
                            class="ml-auto rounded-full px-1 flex items-center justify-center mr-4 bg-white/30"
                            style="width: 39px; height: 39px;"
                            :class="[hasBeenFavorited(session) ? 'bg-white/90': 'bg-white/30']">
                      <svg viewBox="0 0 32 32" width="45" height="45" class="flex-shrink-0 "
                           :class="[hasBeenFavorited(session) ? 'text-[#C00]': 'text-white']">
                        <g stroke="none" stroke-width="1.2" class="fill-current" fill-rule="evenodd">
                          <path class="fill-current"
                                d="M13.6196,11.2 C11.6246857,11.2 10.4,12.85425 10.4,14.2106375 C10.4,17.143925 13.9170286,19.8671 16.4,21.6 C18.8829714,19.86645 22.4,17.143925 22.4,14.2106375 C22.4,12.8541363 21.1758971,11.2 19.1804,11.2 C18.0661143,11.2 17.1138286,12.042335 16.4,12.8420625 C15.6854857,12.0422538 14.73392,11.2 13.6196,11.2 Z"></path>
                        </g>
                      </svg>
                    </button>
                  </div>
                </header>
                <div v-show="session.safePreText" v-html="session.safePreText" class="mb-2 mt-2 block text-xs
                 text-white text-opacity-90" :class="{'hidden': compactness > 1}">
                </div>
                <div class="mb-2 mt-2 block text-xs font-bold uppercase text-white text-opacity-75"
                     :class="{'lg:hidden': compactness < 2}">
                  <template v-if="session.is_asynchronous">
                    Async <span class="delimiter text-white font-bold"> • </span>
                  </template>
                  <template v-else-if="session.starts_at">
                    {{ getDate(session) }} <span class="delimiter text-white font-bold"> • </span>
                    {{ getTime(session) }} <span class="delimiter text-white font-bold"> • </span>
                    {{ getLength(session) }} <span class="delimiter text-white font-bold"> • </span>
                  </template>
                  <template v-else>
                    Unscheduled <span class="delimiter text-white font-bold"> • </span>
                  </template>
                  <template v-if="hasVirtualLocation(session)">
                    <a class="underline" :href="'/session/' + session.id">Enter virtual here</a> <span
                      class="delimiter text-white font-bold"> • </span>
                  </template>
                  <a :href="'/session-types/'+session.type_id">{{ sessionTypeName(session) }}</a> <span
                    class="delimiter text-white font-bold"> • </span>
                  <a :href="'/session-subtypes/'+session.subtype_id">{{ sessionSubTypeName(session) }}</a> <span
                    class="delimiter text-white font-bold"> • </span>
                  <a :href="'/session-formats/'+session.format_id">{{ sessionFormatName(session) }}</a>
                  <template v-if="hasPhysicalLocation(session) && session.location?.id">
                    <span
                        class="delimiter text-white font-bold"> @ </span>
                    <a :href="'/session-locations/' + session.location?.id">
                      {{ physicalLocation(session) }}
                    </a>
                  </template>
                </div>
                <div v-show="compactness < 2" class="mb-4">
                  <p class="font-medium" :class="{'line-clamp-3': compactness > 0}">{{ session.description }}</p>
                </div>
                <div class="hidden lg:block" v-show="compactness < 2">
                  <dl class="flex divide-x divide-solid divide-white/15 md:ml-1">

                    <template v-if="session.cancelled_at">
                      <div class="px-5">
                        <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Date</dt>
                        <dd class="text-sm font-semibold text-white">
                          CANCELLED
                        </dd>
                      </div>
                    </template>
                    <template v-else-if="session.is_asynchronous">
                      <div class="px-5">
                        <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Date</dt>
                        <dd class="text-sm font-semibold text-white">
                          Async
                        </dd>
                      </div>
                    </template>
                    <template v-else-if="!session.starts_at">
                      <div class="px-5">
                        <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Date</dt>
                        <dd class="text-sm font-semibold text-white">
                          -
                        </dd>
                      </div>
                    </template>
                    <template v-else>
                        <div class="px-5">
                            <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Date</dt>
                            <dd @click="changeDate(session)" class="cursor-pointer text-sm font-semibold text-white">
                                {{ getDate(session) }}
                            </dd>
                        </div>
                        <div class="px-5">
                            <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Start</dt>
                            <dd class="text-sm font-semibold text-white">{{ getTime(session) }}</dd>
                        </div>
                        <div class="px-5">
                            <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Length</dt>
                            <dd class="text-sm font-semibold text-white">{{ getLength(session) }}</dd>
                        </div>
                    </template>
                      <div class="px-5">
                          <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Type</dt>
                          <dd class="text-sm font-semibold text-white"><a class="link text-white"
                                                                          :href="'/session-types/' + session.type?.id">
                              {{ sessionTypeName(session) }}
                          </a>
                          </dd>
                      </div>
                      <div class="px-5">
                          <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Subtype</dt>
                          <dd class="text-sm font-semibold text-white"><a class="link text-white"
                                                                          :href="'/session-subtypes/' + session.subtype?.id">
                              {{ sessionSubTypeName(session) }}
                          </a>
                          </dd>
                      </div>
                      <div class="px-5">
                          <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Format</dt>
                          <dd class="text-sm font-semibold text-white"><a class="link text-white"
                                                                          :href="'/session-formats/' + session.format?.id">
                              {{ sessionFormatName(session) }}
                          </a>
                          </dd>
                      </div>
                      <div v-show="hasVirtualLocation(session)" class="px-5">
                          <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Virtual Location</dt>
                          <dd class="text-sm font-semibold text-white">
                              <a class="link text-white" :href="'/session/' + session.id">
                                  <span class="hidden sm:inline">Enter from here</span><span class="md:hidden">Go
                                  here</span>
                              </a>
                          </dd>
                      </div>
                      <div v-show="hasPhysicalLocation(session) && session.location?.id" class="px-5">
                          <dt class="mb-2 font-cabin text-2xs font-medium text-white/75">Physical Location</dt>
                          <dd class="text-sm font-semibold text-white">
                              <a class="link text-white" :href="'/session-locations/' + session.location?.id">
                                  {{ physicalLocation(session) }}
                              </a>
                          </dd>
                      </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="isGetting">
      ...
    </div>
    <div v-else-if="sessions?.length === 0">
      No Results
    </div>
  </div>
</template>

<script>
// https://www.kindacode.com/snippet/tailwind-css-how-to-create-a-sticky-affix-navbar/

import {computed, onMounted, onUnmounted, ref} from "vue";
import axios from "axios";
import qs from "qs";
import moment from "moment-timezone";
import _ from "lodash";

export default {
  setup(props) {



    //const people = ref(_people);
    //const selected = ref(_people[3]);
    const isAllFetched = ref(false);
    const selectedType = ref(0);
    const selectedFormat = ref(0);
    const selectedDay = ref(0);
    const selectedSubType = ref(0);
    const sessions = ref([]);
    const currentPage = ref(0);
    const nextPage = ref(1);
    const isGetting = ref(false);
    const timezone = ref(props.timezone);
    const compactness = ref(0);

    const favorites = ref(props.favoriteSessions);

    function hasBeenFavorited(session) {
      return favorites.value.includes(session.id);
    }

    function typeColor(session) {
      const color = session.type?.color;

      if (color) {
        return color;
      }

      return '#FFF';
    }

    const goCompactMessage = computed(() => {


      if (compactness.value === 1) {
        return 'Go very compact';
      }

      if (compactness.value === 0) {
        return 'Go Compact';
      }
      return 'Revert';
    })

    function changeSearch(event) {
      isAllFetched.value = false;
      sessions.value = [];
      nextPage.value = 1;
      fetchData();
    }

    function participantName(p) {
      if (p.member && p.member?.name) {
        return p.member.name;
      }

      if (p.member && p.member?.user) {
        return p.member.user.name;
      }

      return 'No name';
    }

    const sessionTypes = ref([]);
    const sessionSubTypes = ref([]);
    const sessionFormats = ref([]);

    function fetchTypes() {
      axios.get('/api/event/' + props.event.id + '/list/session_types')
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            sessionTypes.value = response.data;
          })
          .catch(error => {

          });
    }

    function fetchFormats() {
      axios.get('/api/event/' + props.event.id + '/list/session_formats')
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            sessionFormats.value = response.data;
          })
          .catch(error => {

          });
    }

    function fetchSubTypes() {
      axios.get('/api/event/' + props.event.id + '/list/session_sub_types')
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            sessionSubTypes.value = response.data;
          })
          .catch(error => {

          });
    }

    fetchTypes();
    fetchSubTypes();
    fetchFormats();


    function fetchData() {

      if (isGetting.value || isAllFetched.value) {
        return;
      }
      alternatingDate = 1;
      // https://stackoverflow.com/questions/49944387/how-to-correctly-use-axios-params-with-arrays
      isGetting.value = true;
      axios.get('/search/sessions',
          {
            params: {
              isFavorite: 0,
              timezone: timezone.value,
              sessionDay: selectedDay.value,
              sessionType: selectedType.value,
              sessionFormat: selectedFormat.value,
              sessionSubType: selectedSubType.value,
              page: nextPage.value,
            },
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          })
          .then(response => {
            const query = response.data;
            const newSessions = query.data;

            if (newSessions.length) {
              sessions.value.push(...newSessions);
              nextPage.value++;
              isAllFetched.value = false;
            } else {
              isAllFetched.value = true;
            }


            currentPage.value = query.currentPage;
          })
          .finally(() => {

            isGetting.value = false;
              }
          )
          .catch(error => {

          });
      //axios.get(this.url+'?code='+this.code)
    }

    function participantCountGreater(session, lim) {
      const count = session.participants ? session.participants.length : 0;

      return count > lim;

    }

    fetchData();

    const scrollComponent = ref(null);
    // on the div in the template

    const bottom = ref(0);

    const doGetData = ref(false);

    const inner = ref(window.innerHeight);

    // https://vueschool.io/articles/vuejs-tutorials/build-an-infinite-scroll-component-using-intersection-observer-api/
    // https://learnvue.co/2020/09/a-quick-vue3-infinite-scrolling-component-daily-vue-tips-4/


    onMounted(() => {
      window.addEventListener("scroll", handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll)
    })


    function handleScroll(e) {
      //let element = document.getElementById('edz_scroller');
      let element = scrollComponent.value;
      bottom.value = element.getBoundingClientRect().bottom;
      //console.log(element.getBoundingClientRect().bottom);
      //console.log(window.innerHeight);

      // goes down < fixed, so we make the fixed a bit higher
      if (element.getBoundingClientRect().bottom < (window.innerHeight + 50) ) {
        doGetData.value = true;
        fetchData();
      }
    }

    function sessionTypeName(session) {
      if (session.type != null) {
        return session.type.name;
      }
      return '-';
    }

    function sessionSubTypeName(session) {
      if (session.subtype != null) {
        return session.subtype.name;
      }
      return '-';
    }

    function sessionFormatName(session) {
      if (session.format != null) {
        return session.format.name;
      }
      return '-';
    }

    function sessionLocationName(session) {
      if (session.type != null) {
        return session.type.name;
      }
      return '-';
    }

    function secondsToHms(d) {
      d = Number(d);
      const h = Math.floor(d / 3600);
      const m = Math.floor(d % 3600 / 60);
      const s = Math.floor(d % 3600 % 60);

      const hDisplay = h > 0 ? h + 'h' : "";
      const mDisplay = m > 0 ? m + 'm' : "";
      //const sDisplay = s > 0 ? s + 's': "";
      return hDisplay + mDisplay; // + sDisplay;
    }

    function getLength(session) {
      const isoTimeStart = session.starts_at;
      if (!isoTimeStart) {
        return '-';
      }
      const isoTimeEnd = session.ends_at;
      if (!isoTimeStart) {
        return '∞';
      }
      const start = moment.tz(isoTimeStart, timezone.value);
      const end = moment.tz(isoTimeEnd, timezone.value);
      const duration = moment.duration(end.diff(start));

      const seconds = duration.asSeconds();

      if (seconds > 86400) {
        return '>24hr';
      }

      return secondsToHms(seconds);
    }

    function getDate(session) {
      const isoTimeStart = session.starts_at;

      if (!isoTimeStart) {
        return '-';
      }

      const localTimeStart = moment.tz(isoTimeStart, timezone.value);
      return localTimeStart.format('MMM Do');
    }

    function changeDate(session) {
      const isoTimeStart = session.starts_at;

      if (!isoTimeStart) {
        return
      }

      const localTimeStart = moment.tz(isoTimeStart, timezone.value);
      const time = localTimeStart.format('Y-MM-DD');

      if (selectedDay.value !== time) {
        selectedDay.value = time;
        changeSearch();
      }
    }

    function getTime(session) {

      const isoTimeStart = session.starts_at;


      if (!isoTimeStart) {
        return '-';
      }

      const localTimeStart = moment.tz(isoTimeStart, timezone.value);
      return localTimeStart.format('HH:mm');
      /*


      return;
      let dayStart = '';
      let timeStart = '';
      let localTimeStart = '';
      if (isoTimeStart) {

      }
      let dayEnd = '';
      let timeEnd = '';
      let localTimeEnd = '';
      if (isoTimeEnd) {
        localTimeEnd = moment.tz(isoTimeEnd, timezone.value);
        dayEnd = localTimeEnd.format('MMMM Do');
        timeEnd = localTimeEnd.format('ddd, MMM Do, HH:mm ' + this.shortTimeZone);
      }

      if (dayStart && (dayStart === dayEnd)) {
        return localTimeStart.format('ddd, MMM Do, HH:mm') + ' ~ ' + localTimeEnd.format('HH:mm ' + this.shortTimeZone);
      }
      return timeStart + ' ~ ' + timeEnd;

       */
    }

      function hasVirtualLocation(session) {
          const location = session?.location;
          if (!location) {
              return false;
          }
          if (location.is_virtual) {
              return true;
          }
          return false;
      }

      function hasPhysicalLocation(session) {

          const location = session?.location;
          if (!location) {
              return false;
          }
          if (location.physical_address || location.name) {
              return true;
          }

          return false;

      }

      function physicalLocation(session) {
          const location = session?.location;

          if (!location || (!location.physical_address && !location.name)) {
              return 'Not yet set';
          }

          return location.physical_address ? location.name + ' : ' + location.physical_address : location.name;
      }

      /*
      { "id": 539, "name": "6. Technology", "event_id": 47, "physical_address": null, "notes": null,
      "building_id": null, "is_virtual": false, "linkName": "", "building": null }
       */

      function virtualLocation(session) {
          return '';
      }

      const localDays = ref([]);

      function fetchLocalDays() {
          axios.get('/api/event/' + props.event.id + '/list/session_local_days')
              .then(response => {
                  localDays.value = response.data;
              })
              .catch(error => {


              });
      }

      fetchLocalDays();

      function sessionLeadImage(session) {
          if (session.participants?.length) {
              const lead = session.participants[0];
              if (lead?.member?.avatar_path) {
                  return lead?.member?.avatar_path;
              }
          }
          return '/img/user-astronaut-square.png';
      }

      function sessionLeadLink(session) {
          if (session.participants?.length) {
              const lead = session.participants[0];
              if (lead?.member?.id) {
                  return '/person/' + lead?.member?.id;
              }
          }
          return '#';
      }

      function makeCompact() {
          compactness.value++;
          if (compactness.value > 2) {
              compactness.value = 0;
          }
      }

      let alternatingDate = 1;

      function newDate(oldSession, newSession) {
          //console.log(newSession.id);
          //console.log(alternatingDate);
          if (!oldSession) {
              alternatingDate = 1;

              alternatingDate = alternatingDate % 2;
              return 'alt-date-' + alternatingDate;
          }

          const oldDate = getDate(oldSession);
          const newDate = getDate(newSession);

          if (oldDate !== newDate) {
              alternatingDate++;
          }
          alternatingDate = alternatingDate % 2;
          return 'alt-date-' + alternatingDate;
          //return true;
      }

    function toggleFavorite(session) {
      const loved = favorites.value.includes(session.id);
      loved ? removeFavorite(session) : addFavorite(session);
    }

    function addFavorite(session) {
      axios.post('/session/' + session.id + '/favorite').then(response => {
        favorites.value.push(session.id);
      })
    }
    function removeFavorite(session) {
      axios.delete('/session/' + session.id + '/favorite').then(response => {
        const index = favorites.value.indexOf(session.id);
        if (index !== -1) {
          favorites.value.splice(index, 1);
        }
      })
    }

    return {
        toggleFavorite,
        alternatingDate,
        newDate,
        makeCompact,
        compactness,
        sessionLeadImage,
        sessionLeadLink,
        hasVirtualLocation,
        hasPhysicalLocation,
        physicalLocation,
        localDays,
        sessions,
        scrollComponent,
        bottom,
        inner,
        doGetData,
        currentPage,
        nextPage,
        isGetting,
        timezone,
        sessionTypes,
        selectedType,
        sessionFormats,
        selectedFormat,
        selectedDay,
        sessionSubTypes,
        selectedSubType,
        changeSearch,
        goCompactMessage,
        getTime,
        sessionTypeName,
        sessionSubTypeName,
        sessionLocationName,
        sessionFormatName,
        getDate,
        getLength,
        participantName,
        participantCountGreater,
        isAllFetched,
        typeColor,
        changeDate,
        hasBeenFavorited
    }
  },
  props:
      {
        timezone: {
          type: String,
          required: true
        },
        event: {
          type: Object,
          required: true
        },
        favoriteSessions: {
          type: Array,
          default() {
            return [];
          },
          required: true
        },
      }
}
</script>

<style scoped>
.alt-date-1 {
  /* background: linear-gradient(90deg, #5ac3be, #46da35);
  background: linear-gradient(90deg, #5ac3be, #46da35);
  000428 → #004e92
  36d1dc → #5b86e5
  #aa076b → #61045f
  F20188 F9F870
  https://www.b3multimedia.ie/beautiful-color-gradients-for-your-next-design-project/
  */
  background: linear-gradient(90deg, #000428, #004e92);
  background: linear-gradient(90deg, #5ac3be, #46da35);
  background: linear-gradient(90deg, #2193b0, #6dd5ed);

  background: linear-gradient(280deg, #36d1dc, #5b86e5);

  background: linear-gradient(280deg, #02AABD, #00CDAC);
  background: linear-gradient(100deg, #F20188, #F9F870);
  background: linear-gradient(100deg, #F20188, #46da35);
  background: linear-gradient(100deg, #0161f2, #3dccec);
  background: linear-gradient(280deg, #aa076b, #61045f);

  /* rgba(200, 223, 255, 0.4); */

}

.alt-date-0 {
  background: linear-gradient(100deg, #0161f2, #3dccec);
  background: linear-gradient(100deg, #000428, #004e92);
}

li.session-wrap a:hover {
  opacity: 0.6;

}

.header-gradient-hide {
  background: linear-gradient(90deg, #FFF, #DDD);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
